// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"_2FSWm0jU8dcDd9I8FFMlmc","modal":"_29wvt09602t2t_69kLz1og","shrink-bounce":"_29pWdCIuqUHIq7kLjomD7O","title":"_2s_v_d_P02E5CeZ407i5io","titleforRSD":"_2hOvKdC8IqimYuzAhCAOWG","content":"_3qfVZ25qzw4vg37fuhYYL_","closeButton":"_2w2L1U9kPCSfVo9wIhxnxE","topBar":"_3tdQR3xxKL-ArMFGl7enTz","alert":"_27T_8AXlUV1mBRpTuHiK51","warning":"_1MXC-ueoFJkWFOhuoHHHo1","info":"_2El4w3_mRkdAtg1KoKizbr","success":"_2yf5vbEYh3tMjjpbnabY3D","realityCheck":"PlbJEduCdZzfLlr4CYndZ","realityCheckContainer":"_1tAR9oAEGodVO_Ze78kPf5","alertContent":"_3hSjg5L334RhZxGm6_YHYh"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/modalPopup.css
// module id = 860
// module chunks = 0